import React from 'react'
import { useTranslation } from 'react-i18next'
import { ConsignmentItem } from '../../consignment-item/models/types'
import ConsignmentItemsTableRowDetails from './ConsignmentItemsTableRowDetails'

export interface TransitPreviewGoodsItemRowProps {
  consignmentItem: ConsignmentItem
  isExpanded: boolean
  itemSequenceNumber: number
  onRowToggle: () => void
}

function ConsignmentItemsTableRow({
  consignmentItem,
  isExpanded,
  itemSequenceNumber,
  onRowToggle,
}: TransitPreviewGoodsItemRowProps) {
  const { t } = useTranslation()

  const {
    id,
    commodityDescriptionOfGoods,
    commodityCombinedNomenclatureCode,
    commodityHarmonizedSystemSubHeadingCode,
  } = consignmentItem

  return (
    <div className="w-100">
      <div className="border-bottom mb-2">
        <button
          type="button"
          className="heading my-2 mb-2 w-100 d-flex align-items-center justify-content-between"
          data-bs-toggle="collapse"
          data-bs-target={`#${id}`}
          aria-expanded={isExpanded}
          aria-controls={`${id}`}
          onClick={onRowToggle}
        >
          <h4 className="goods-item-title d-flex align-items-start mb-0">
            <span className="flex-shrink-0 ps-2">
              <span>{t('declaration.p5.sequenceNumber')}</span>
              <span className="px-1">
                {(itemSequenceNumber ?? 0) + 1}
              </span>
            </span>
            <span className="commodity-description ps-3 pe-1" title={commodityDescriptionOfGoods}>
              {commodityDescriptionOfGoods}
            </span>
            <span className="flex-shrink-0 px-1 commodity-code">
              {`${commodityHarmonizedSystemSubHeadingCode} ${commodityCombinedNomenclatureCode}`}
            </span>
          </h4>
          <i className={`mx-2 fa ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
        </button>
      </div>
      <div
        className={`collapse ${isExpanded ? 'show mb-3' : ''}`}
        id={`${id}`}
      >
        {isExpanded && (
          <ConsignmentItemsTableRowDetails consignmentItem={consignmentItem} />
        )}
      </div>
    </div>
  )
}

export default ConsignmentItemsTableRow
